var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news-list"},_vm._l((_vm.newsList),function(news){return _c('div',{key:news.id},[_c('news-card',{key:news.newsId,attrs:{"news":news,"show-opened":true,"show-read":true},on:{"read":function($event){return _vm.markAsRead(news.newsId)}}}),_c('br')],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }